import { ActionType, createAction } from "typesafe-actions";

import Legend from "@app/enum/map/Legend";

export const toggleLegendVisibility = createAction("mapLegends/toggleVisibility")<{
  name: Legend;
  visible: boolean;
}>();

export const toggleLegendExpandedState = createAction("mapLegends/toggleExpandedState")<{
  expanded: boolean;
  name: Legend;
}>();

export type MapLegendsActions = ActionType<
  typeof toggleLegendExpandedState | typeof toggleLegendVisibility
>;
